/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

riot.mixin('i18n', {
	init: function() {
		this.on('mount unmount', function(evt) {
			if (evt === 'mount') {
				riotctrl.on('update-i18n-retro', this.onUpdateI18n, this);
			}
			else if (evt === 'unmount') {
				riotctrl.off('update-i18n-retro', this.onUpdateI18n, this);
			}
		});

		this.on('update', function() {
			// force a scan just in case the DOM changed
			this.onUpdateI18n();
		});
	},

	onUpdateI18n: function() {
		var labels = this.root.querySelectorAll('[data-i18n]');
		for (var i = 0; i < labels.length; i++) {
			var e = labels[i];
			var k = e.dataset.i18n;
			e.innerText = iaw.i18n.getLocalizedString(k);
		}
	}
});
